/**
 * @generated SignedSource<<7bd33b2e07811cd65eebc9299753939a>>
 * @relayHash 6dd6a409893529c7bec6c5077811a50d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 466f7916e1c0042d12f0e8991a1f98bf77cc909b62057983632d8581ca590509

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceBlogPostStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluenceContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluenceContentType = "ATTACHMENT" | "BLOG_POST" | "COMMENT" | "DATABASE" | "EMBED" | "FOLDER" | "PAGE" | "WHITEBOARD" | "%future added value";
export type ConfluencePageStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluencePageSubType = "LIVE" | "%future added value";
export type RecentContentMenuQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  eventTypes?: ReadonlyArray<string> | null | undefined;
  first?: number | null | undefined;
  objectTypes?: ReadonlyArray<string> | null | undefined;
};
export type RecentContentMenuQuery$data = {
  readonly activity: {
    readonly myActivity: {
      readonly all: {
        readonly edges: ReadonlyArray<{
          readonly cursor: string;
          readonly node: {
            readonly event: {
              readonly eventType: string;
              readonly id: string;
              readonly timestamp: AGG$DateTime;
            };
            readonly id: string;
            readonly object: {
              readonly data: {
                readonly blogStatus?: ConfluenceBlogPostStatus | null | undefined;
                readonly commentId?: string | null | undefined;
                readonly container?: {
                  readonly blogStatus?: ConfluenceBlogPostStatus | null | undefined;
                  readonly createdAt?: string | null | undefined;
                  readonly id?: string;
                  readonly links?: {
                    readonly editUi: string | null | undefined;
                    readonly webUi: string | null | undefined;
                  } | null | undefined;
                  readonly metadata?: {
                    readonly titleEmojiDraft: {
                      readonly value: string | null | undefined;
                    } | null | undefined;
                    readonly titleEmojiPublished: {
                      readonly value: string | null | undefined;
                    } | null | undefined;
                  } | null | undefined;
                  readonly pageStatus?: ConfluencePageStatus | null | undefined;
                  readonly space?: {
                    readonly alias: string | null | undefined;
                    readonly id: string;
                    readonly key: string | null | undefined;
                    readonly name: string | null | undefined;
                  } | null | undefined;
                  readonly status?: ConfluenceContentStatus | null | undefined;
                  readonly subtype?: ConfluencePageSubType | null | undefined;
                  readonly title?: string | null | undefined;
                  readonly type?: ConfluenceContentType | null | undefined;
                  readonly viewer?: {
                    readonly favoritedSummary: {
                      readonly isFavorite: boolean;
                    } | null | undefined;
                  } | null | undefined;
                } | null | undefined;
                readonly createdAt?: string | null | undefined;
                readonly id?: string;
                readonly links?: {
                  readonly editUi: string | null | undefined;
                  readonly webUi: string | null | undefined;
                } | null | undefined;
                readonly metadata?: {
                  readonly titleEmojiDraft: {
                    readonly value: string | null | undefined;
                  } | null | undefined;
                  readonly titleEmojiPublished: {
                    readonly value: string | null | undefined;
                  } | null | undefined;
                } | null | undefined;
                readonly pageStatus?: ConfluencePageStatus | null | undefined;
                readonly space?: {
                  readonly alias: string | null | undefined;
                  readonly id: string;
                  readonly key: string | null | undefined;
                  readonly name: string | null | undefined;
                } | null | undefined;
                readonly status?: ConfluenceContentStatus | null | undefined;
                readonly subtype?: ConfluencePageSubType | null | undefined;
                readonly title?: string | null | undefined;
                readonly type?: ConfluenceContentType | null | undefined;
                readonly viewer?: {
                  readonly favoritedSummary: {
                    readonly isFavorite: boolean;
                  } | null | undefined;
                } | null | undefined;
              } | null | undefined;
              readonly id: string;
            };
          };
        }>;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
          readonly hasNextPage: boolean;
        };
      };
    } | null | undefined;
  } | null | undefined;
};
export type RecentContentMenuQuery = {
  response: RecentContentMenuQuery$data;
  variables: RecentContentMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventTypes"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "objectTypes"
},
v5 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "eventTypes",
            "variableName": "eventTypes"
          },
          {
            "kind": "Variable",
            "name": "objectTypes",
            "variableName": "objectTypes"
          },
          {
            "kind": "Literal",
            "name": "products",
            "value": [
              "CONFLUENCE"
            ]
          }
        ],
        "kind": "ObjectValue",
        "name": "arguments"
      },
      {
        "items": [
          {
            "kind": "Variable",
            "name": "rootContainerIds.0",
            "variableName": "cloudId"
          }
        ],
        "kind": "ListValue",
        "name": "rootContainerIds"
      },
      {
        "kind": "Literal",
        "name": "type",
        "value": "AND"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "title"
},
v9 = {
  "kind": "ScalarField",
  "name": "type"
},
v10 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v11 = {
  "kind": "ScalarField",
  "name": "webUi"
},
v12 = [
  (v11/*: any*/),
  {
    "kind": "ScalarField",
    "name": "editUi"
  }
],
v13 = [
  {
    "concreteType": "ConfluenceFavoritedSummary",
    "kind": "LinkedField",
    "name": "favoritedSummary",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isFavorite"
      }
    ]
  }
],
v14 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ]
},
v15 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v16 = {
  "concreteType": "ConfluenceContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ConfluenceContentTitleEmoji",
      "kind": "LinkedField",
      "name": "titleEmojiDraft",
      "plural": false,
      "selections": (v15/*: any*/)
    },
    {
      "concreteType": "ConfluenceContentTitleEmoji",
      "kind": "LinkedField",
      "name": "titleEmojiPublished",
      "plural": false,
      "selections": (v15/*: any*/)
    }
  ]
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "kind": "ScalarField",
      "name": "subtype"
    },
    {
      "alias": "pageStatus",
      "kind": "ScalarField",
      "name": "status"
    },
    (v10/*: any*/),
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v12/*: any*/)
    },
    {
      "concreteType": "ConfluencePageViewerSummary",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": (v13/*: any*/)
    },
    (v14/*: any*/),
    (v16/*: any*/)
  ],
  "type": "ConfluencePage"
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "alias": "blogStatus",
      "kind": "ScalarField",
      "name": "status"
    },
    (v10/*: any*/),
    {
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v12/*: any*/)
    },
    {
      "concreteType": "ConfluenceBlogPostViewerSummary",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": (v13/*: any*/)
    },
    (v14/*: any*/),
    (v16/*: any*/)
  ],
  "type": "ConfluenceBlogPost"
},
v19 = {
  "kind": "ScalarField",
  "name": "status"
},
v20 = [
  (v11/*: any*/)
],
v21 = {
  "concreteType": "ConfluenceContentViewerSummary",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v13/*: any*/)
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v19/*: any*/),
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v20/*: any*/)
    },
    (v21/*: any*/),
    (v14/*: any*/)
  ],
  "type": "ConfluenceWhiteboard"
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v19/*: any*/),
    {
      "concreteType": "ConfluenceDatabaseLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v20/*: any*/)
    },
    (v21/*: any*/),
    (v14/*: any*/)
  ],
  "type": "ConfluenceDatabase"
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v19/*: any*/),
    {
      "concreteType": "ConfluenceSlideLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v20/*: any*/)
    },
    (v21/*: any*/),
    (v14/*: any*/)
  ],
  "type": "ConfluenceSlide"
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v19/*: any*/),
    {
      "concreteType": "ConfluenceEmbedLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v20/*: any*/)
    },
    (v21/*: any*/),
    (v14/*: any*/),
    (v16/*: any*/)
  ],
  "type": "ConfluenceEmbed"
},
v26 = {
  "kind": "ScalarField",
  "name": "commentId"
},
v27 = [
  (v7/*: any*/),
  (v26/*: any*/),
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v17/*: any*/),
      (v18/*: any*/),
      (v22/*: any*/)
    ]
  }
],
v28 = {
  "concreteType": "ActivityEvent",
  "kind": "LinkedField",
  "name": "event",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "name": "timestamp"
    },
    {
      "kind": "ScalarField",
      "name": "eventType"
    }
  ]
},
v29 = {
  "concreteType": "ActivityPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v30 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v31 = [
  (v7/*: any*/)
],
v32 = {
  "kind": "InlineFragment",
  "selections": (v31/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v33 = [
  (v7/*: any*/),
  (v26/*: any*/),
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v30/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v22/*: any*/),
      (v32/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RecentContentMenuQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "concreteType": "MyActivity",
            "kind": "LinkedField",
            "name": "myActivity",
            "plural": false,
            "selections": [
              {
                "args": (v5/*: any*/),
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "all",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ActivityItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "concreteType": "ActivityNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "concreteType": "ActivityObject",
                            "kind": "LinkedField",
                            "name": "object",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v27/*: any*/),
                                    "type": "ConfluenceInlineComment"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v27/*: any*/),
                                    "type": "ConfluenceFooterComment"
                                  }
                                ]
                              }
                            ]
                          },
                          (v28/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v29/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "RecentContentMenuQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "concreteType": "MyActivity",
            "kind": "LinkedField",
            "name": "myActivity",
            "plural": false,
            "selections": [
              {
                "args": (v5/*: any*/),
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "all",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ActivityItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "concreteType": "ActivityNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "concreteType": "ActivityObject",
                            "kind": "LinkedField",
                            "name": "object",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v33/*: any*/),
                                    "type": "ConfluenceInlineComment"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v33/*: any*/),
                                    "type": "ConfluenceFooterComment"
                                  },
                                  (v32/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v31/*: any*/),
                                    "type": "DevOpsPullRequestDetails"
                                  }
                                ]
                              }
                            ]
                          },
                          (v28/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v29/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "6dd6a409893529c7bec6c5077811a50d",
    "id": "466f7916e1c0042d12f0e8991a1f98bf77cc909b62057983632d8581ca590509",
    "metadata": {},
    "name": "RecentContentMenuQuery",
    "operationKind": "query",
    "text": "query RecentContentMenuQuery($cloudId:ID!,$first:Int,$after:String,$eventTypes:[String!],$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND,rootContainerIds:[$cloudId],arguments:{products:[\"CONFLUENCE\"],objectTypes:$objectTypes,eventTypes:$eventTypes}},first:$first,after:$after){edges{cursor,node{id,object{id,data{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name}},...on ConfluenceDatabase{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name}},...on ConfluenceSlide{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name}},...on ConfluenceEmbed{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceInlineComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on ConfluenceFooterComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on Node{__isNode:__typename,id},...on DevOpsPullRequestDetails{id}}},event{id,timestamp,eventType}}},pageInfo{hasNextPage,endCursor}}}}}"
  }
};
})();

(node as any).hash = "f9585d13f5d9c4885250268904a58e2a";

export default node;
